import { HTMLProps } from 'react'
import useEquipmentProtocol from '@/pages/Equipment/hooks/useEquipmentProtocol.ts'
import { IProtocol } from '@/pages/Equipment/equipment.types.ts'

interface IProps {
  protocolId: IProtocol['id']
}

const EquipmentProtocolNameSpan = ({ protocolId, ...props }: IProps & HTMLProps<HTMLSpanElement>) => {
  const protocol = useEquipmentProtocol(protocolId)

  return <span {...props}>{protocol ? protocol.nameRu : '-'}</span>
}

export default EquipmentProtocolNameSpan
